import type { ReactNode } from 'react';

export type StatusTone = 'success' | 'warning' | 'error' | 'info' | 'neutral';

interface StatusPillProps {
  tone?: StatusTone;
  children: ReactNode;
}

const TONE_COLOR: Record<StatusTone, string> = {
  success: 'var(--color-success)',
  warning: 'var(--color-warning)',
  error:   'var(--color-error)',
  info:    'var(--color-info)',
  neutral: 'var(--text-secondary)',
};

/**
 * Status chip / pill — matches the Figma "chips" component: pill radius, a ~15%
 * tint of the tone colour, a 1px tone border, and a tone-coloured label.
 */
export function StatusPill({ tone = 'neutral', children }: StatusPillProps): JSX.Element {
  const color = TONE_COLOR[tone];
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        height: 26,
        padding: '0 12px',
        borderRadius: 999,
        fontSize: 13,
        fontWeight: 500,
        lineHeight: 1,
        whiteSpace: 'nowrap',
        color,
        border: `1px solid ${color}`,
        backgroundColor: `color-mix(in srgb, ${color} 14%, transparent)`,
      }}
    >
      {children}
    </span>
  );
}
